import { exhaustiveFail } from '@cbridge-utils/error';
import { IApiLpSymbol, IApiGetLpSymbolsReq } from '@cbridge-packages/api';
import { MarkupTranslator } from '@cbridge-packages/markup';
import { ScheduleTranslator } from '@cbridge-packages/schedule';
import { ISymbolLp, ISymbolLpKey, LpSymbolsFilter, ILpSymbolName } from './symbolLp.interface';

export namespace SymbolLpTranslator {
  export function fromApi(symbol: IApiLpSymbol): ISymbolLp {
    return {
      name: symbol.name,
      coreSymbolId: symbol.coreSymbolId,
      coreSymbolName: symbol.coreSymbolName,
      priceMultiplier: symbol.priceMultiplier,
      volumeMultiplier: symbol.volumeMultiplier,
      bidMarkup: symbol.bidMarkup,
      askMarkup: symbol.askMarkup,
      markupType: MarkupTranslator.fromApiMarkupType(symbol.markupType),
      minVolume: symbol.minVolume,
      maxVolume: symbol.maxVolume,
      stepVolume: symbol.stepVolume,
      schedule: symbol.schedule
        ? ScheduleTranslator.fromApiFullView(symbol.schedule)
        : undefined,
    };
  }

  export function toApi(symbol: Partial<ISymbolLp>): IApiLpSymbol {
    return {
      name: symbol.name,
      coreSymbolId: symbol.coreSymbolId,
      priceMultiplier: symbol.priceMultiplier,
      volumeMultiplier: symbol.volumeMultiplier,
      bidMarkup: symbol.bidMarkup,
      askMarkup: symbol.askMarkup,
      markupType: MarkupTranslator.toApiMarkupType(symbol.markupType),
      minVolume: symbol.minVolume,
      maxVolume: symbol.maxVolume,
      stepVolume: symbol.stepVolume,
    };
  }

  function toApiLpSymbolsIncludeUnmapped(filter?: LpSymbolsFilter): boolean {
    if (!filter) {
      return undefined;
    }

    switch (filter) {
      case LpSymbolsFilter.Mapped:
        return false;
      case LpSymbolsFilter.Unmapped:
        return true;
      default:
        return exhaustiveFail(filter);
    }
  }

  function toApiSort(sort?: string[]): string | undefined {
    if (sort && sort.length > 0) {
      return sort.join(',');
    }
    return undefined;
  }

  export function toApiPayload(payload: ISymbolLpKey): IApiGetLpSymbolsReq {
    return {
      lpId: payload.lpId,
      limit: payload.limit,
      skip: payload.skip,
      symbolGroup: payload.symbolGroup,
      search: payload.search,
      includeUnmapped: toApiLpSymbolsIncludeUnmapped(payload.filter),
      sort: toApiSort(payload.sort),
    };
  }

  export function fromApiUnmapped(symbol: IApiLpSymbol): ILpSymbolName {
    return {
      value: symbol.coreSymbolId,
      label: symbol.coreSymbolName,
    };
  }
}
